import "./Permission.css";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import StepIndicator from "./StepIndicator";
import Support from "../../contact-popup-module/Support";
import NetworkSpeed from "../internet-strength/NetworkSpeed";
import InternetSignal from "../internet-strength/InternetSignal";
import CloseIcon from "@mui/icons-material/Close";
import {
  
  IconButton,
 
} from "@mui/material";

const Permission = () => {

  const [cameraPermission, setCameraPermission] = useState(false);
  const [locationPermission, setLocationPermission] = useState(false);
  const [openPermissionDialog, setOpenPermissionDialog] = useState(false);
  const [openLocPermissionDialog, setOpenLocPermissionDialog] = useState(false);
  const [openCamPermissionDialog, setOpenCamPermissionDialog] = useState(false);
  const [openAudioPermissionDialog, setOpenAudioPermissionDialog] = useState(false);
  const [dialogWidth, setDialogWidth] = useState("29vw");
  const [dialogText, setDialogText] = useState("0.9rem");
  const [locationPermStatus, setLocationPermStatus] = useState("denied");
  const [proceedStatus, setProceedStatus] = useState(false);
  const [cameraPermStatus, setCameraPermStatus] = useState();
  const [audioPermission,setAudioPermission]=useState(false);
  const [audioPermStatus, setAudioPermStatus] = useState();
  const [deviceType, setDeviceType] = useState("Unknown Device"); // Mock device type for demonstration
  const navigate = useNavigate();
  const { audit_id } = useParams();
  const [openDialogLowInternet, setOpenDialogLowInternet] = useState(true);
  const [speed, setSpeed] = useState(null);
  const camera_gif = `${process.env.PUBLIC_URL}/inspection-images/camera.gif`;
  const location_gif = `${process.env
    .PUBLIC_URL}/inspection-images/location.gif`;
  const location_icon = `${process.env.PUBLIC_URL}/custom-icons/location.png`;
  const camera_icon = `${process.env.PUBLIC_URL}/custom-icons/camera.png`;
  const audio_icon = `${process.env.PUBLIC_URL}/custom-icons/audio.png`;
  const tick_icon = `${process.env.PUBLIC_URL}/custom-icons/tick.png`;
  const query_icon = `${process.env.PUBLIC_URL}/custom-icons/query.png`;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 400) {
        setDialogWidth("85vw");
      } else if (window.innerWidth <= 475) {
        setDialogWidth("74vw");
      } else if (window.innerWidth <= 550) {
      } else if (window.innerWidth <= 575) {
        setDialogText("0.6rem");
        setDialogWidth("64vw");
      } else if (window.innerWidth <= 650) {
        setDialogWidth("60vw");
      } else if (window.innerWidth <= 775) {
        setDialogWidth("57vw");
      } else if (window.innerWidth <= 875) {
        setDialogWidth("55vw");
      } else if (window.innerWidth <= 1000) {
        setDialogWidth("48vw");
      } else if (window.innerWidth <= 1100) {
        setDialogWidth("45vw");
        setDialogText("0.8rem");
      } else if (window.innerWidth <= 1300) {
        setDialogWidth("40vw");
      } else {
        setDialogWidth("35vw");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
 console.log(deviceType,"deviceType")
  useEffect(() => {
    const checkPermissions = async() => {
      // Check Camera Permission
      await navigator.permissions.query({ name: "camera" }).then(result => {
        setCameraPermission(result.state === "granted");
        setCameraPermStatus(result.state);
      });

      // Check Location Permission
      await navigator.permissions.query({ name: "geolocation" }).then(result => {
        setLocationPermission(result.state === "granted");
        setLocationPermStatus(result.state);
        console.log("hey location ",result.state )

        navigator.geolocation.getCurrentPosition(
          () => {
            console.log("hello location ", )

            setLocationPermission(true);
            setOpenLocPermissionDialog(false);
            setLocationPermStatus("granted");
          },
          // () => {
          //   setLocationPermStatus("denied")
          //   alert("Location permission denied")
          // }
        )
       
 
      });
      const permissionStatus = await navigator.permissions.query({ name: "microphone" });
      console.log(permissionStatus)
      setAudioPermission(permissionStatus.state === "granted");
      setAudioPermStatus(permissionStatus.state);
      // try {
      //   // Request audio permission
      //   const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      //   console.log('Audio permission granted');
      //   // Stop the stream immediately to avoid using unnecessary resources
      //   stream.getTracks().forEach(track => track.stop());
      //   // Handle the granted permission status
      //   // setAudioPermStatus('granted');
      //    setAudioPermission(true);
      //    setAudioPermStatus("granted");
      // } catch (error) {
      //   console.error('Audio permission denied', error);
      //   // Handle the denied permission status
      //   setAudioPermission(false);
      //    setAudioPermStatus("denied");
      // }
    };

    // Check permissions initially and then every 2 seconds
    checkPermissions();
    const interval = setInterval(checkPermissions, 2000);
    if (/Android/i.test(navigator.userAgent)) {
      setDeviceType("Android");
    } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      setDeviceType("iPhone");
    } else if (/Win|Mac|Linux/i.test(navigator.userAgent)) {
      setDeviceType("Laptop");
    }

    return () => clearInterval(interval);

   
  }, []);


  
  console.log(audioPermStatus,"137")
  useEffect(
    () => {
      setProceedStatus(
        cameraPermStatus === "prompt" && locationPermStatus === "prompt"  && audioPermStatus === "prompt"
          ? false
          : cameraPermStatus === "granted" && locationPermStatus === "granted" && audioPermStatus === "granted"
            ? true
            : cameraPermStatus === "denied" || locationPermStatus === "denied" || audioPermStatus === "denied"
              ? false
              : false
      );
    },
    [cameraPermStatus, locationPermStatus,audioPermStatus]
  );
  // console.log(proceedStatus,"106");

  console.log(locationPermStatus, cameraPermStatus, "97");
  const requestCameraPermission = () => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(() => {
        setCameraPermission(true);
        setOpenCamPermissionDialog(false);
      })
      .catch(() => alert("Camera permission denied"));
  };

  const requestLocationPermission = () => {
    navigator.geolocation.getCurrentPosition(
      () => {
        setLocationPermission(true);
        setOpenLocPermissionDialog(false);
      },
      () => {
        setLocationPermStatus("denied")
        alert("Location permission denied")
      }

    );
  };
  const testSpeed = async () => {
    
    const fileSize = 5 * 1024 * 1024; // 5MB file
    const testFile = 'https://speed.cloudflare.com/__down?bytes=5000000'; // Cloudflare test file

    const startTime = new Date().getTime();

    try {
      const response = await fetch(testFile);
      await response.arrayBuffer();

      const endTime = new Date().getTime();
      const durationInSeconds = (endTime - startTime) / 1000;
      const speedMbps = (fileSize / durationInSeconds / (1024 * 1024) * 8).toFixed(2);

      setSpeed(speedMbps);
    } catch (error) {
      console.error('Speed test failed:', error);
      setSpeed('Error');
    }

  };
  useEffect(() => {
    const intervalId = setInterval(testSpeed, 2000); // Poll every 2 seconds
    
    // Cleanup function to clear the interval when the component unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  const network = `${process.env.PUBLIC_URL}/custom-icons/network.png`;
  const requestAudioPermission = async () => {
    try {
      // Request audio permission
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      console.log('Audio permission granted');
      // Stop the stream immediately to avoid using unnecessary resources
      stream.getTracks().forEach(track => track.stop());
      // Handle the granted permission status
      setAudioPermStatus('granted');
      setOpenLocPermissionDialog(false);
    } catch (error) {
      console.error('Audio permission denied', error);
      // Handle the denied permission status
      setAudioPermStatus('denied');
      setOpenLocPermissionDialog(true);
    }
  };
  

  // useEffect(() => {
  //   // Check current audio permission status
  //   navigator.permissions.query({ name: 'microphone' }).then(result => {
  //     if (result.state === 'granted') {
  //       setAudioPermStatus('granted');
  //     } else if (result.state === 'denied') {
  //       setAudioPermStatus('denied');
  //     } else {
  //       setAudioPermStatus('prompt');
  //     }
  //   });
  // }, []);

  const handleRetryAudio = () => {
    requestAudioPermission();
  };

  const handleRequestPermission = () => {
    requestAudioPermission();
  };


  // const handleProceed = () => {
  //     if (cameraPermission && locationPermission) {
  //         navigate(`/audit/${audit_id}`);
  //     } else {
  //         setOpenPermissionDialog(true);
  //     }
  // };
  const handleRetry = (type) => {
    console.log(type)
    if(type === "location" && !locationPermission){
      setOpenLocPermissionDialog(true);
    }
    else if(type ==="camera" && !cameraPermission){
      setOpenCamPermissionDialog(true);
    }
    else if(type === "audio" && !audioPermission){
      setOpenAudioPermissionDialog(true)
    }
    // if (!locationPermission && !cameraPermission && !audioPermission) {
    //   setOpenPermissionDialog(true);
    // } 
    // else if (!locationPermission) {
    //   setOpenLocPermissionDialog(true);
    // } else if (!cameraPermission) {
    //   setOpenCamPermissionDialog(true);
    // }
    // else if(!audioPermission){
    //   setOpenAudioPermissionDialog(true)
    // }
  };
  const handleDialogClose = event => {
   
    setOpenDialogLowInternet(false);
  };

  const handleButtonClick = async () => {
    if ("geolocation" in navigator) {
      try {
        if (locationPermission && cameraPermission) {
          navigator.geolocation.getCurrentPosition(async position => {
            // const { latitude, longitude } = position.coords;
            // const audit = await getLocation(latitude, longitude);
            //   dispatch(setAuditID(audit_id));
            // navigate("/landing-page");
            navigate(`/audit/photo/${audit_id}`);
          });
        } else if (!locationPermission && !cameraPermission && !audioPermission) {
          setOpenPermissionDialog(true);
        } else if (!locationPermission) {
          setOpenLocPermissionDialog(true);
        } else if (!cameraPermission) {
          setOpenCamPermissionDialog(true);
        }
        else if(!audioPermission)
        {
          setOpenAudioPermissionDialog(true)
        }
      } catch (error) {
        console.error("Error querying location permission:", error);
        // Handle the error appropriately
      }
    } else {
    }
  };
  console.log(proceedStatus, "proceed status");
  const clearImageCache = async () => {
    try {
      const cacheName = 'image-cache';

      // Check if the cache exists
      const cacheExists = await caches.has(cacheName);

      if (cacheExists) {
        // Delete the entire cache
        await caches.delete(cacheName);
        console.log(`${cacheName} cleared successfully.`);
      } else {
        console.log(`${cacheName} does not exist.`);
      }
    } catch (error) {
      console.error('Error clearing the cache:', error);
    }
  };
  useEffect(() => {
    const clearBrowserCache = async () => {
      await clearImageCache();
    }
    clearBrowserCache()
  }, [])
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div
      className="loc-cam-permission-parent"  >
      {/* <img src={query_icon} className="question-div" /> */}
      {speed !==null && <InternetSignal signalStrength={speed}/> }
      <img
        src={query_icon}
        alt="Query Icon"
        className="question-div"
        onClick={handleClickOpen}
      />

      {/* Support Popup */}
      <Dialog open={open} onClose={handleClose} className="support-popup-dialog">
        <DialogContent className="support-popup-content">
          <Support />
          <button onClick={handleClose} className="close-btn">close</button>
        </DialogContent>
      </Dialog>
      <div className="permissions-page">
        <StepIndicator stepNumber={1} />
        <p className="allow-permission-step-indicator">Allow permissions {locationPermStatus}</p>
        <p className="allow-permission-div">Allow permission on your device</p>
        <div className="permission-card-parent">
          {/* camera */}
          <div
            className="permission-card"
          // style={{
          //   position: "relative",
          //   padding: "1rem",
          //   border: "1px solid #ccc",
          //   borderRadius: "4px",
          //   width: "100%",
          //   height: "140px"
          // }}
          >
            {/* <div className="icon-text">
          <i className="icon-camera" />
          <div> */}
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                gap: "0.3rem"
              }}
            >
              <img
                src={camera_icon}
                style={{ width: "20px", height: "19px" }}
              />
              <p
                style={{
                  fontFamily: "Barlow Condensed",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: ' #000000DE'
                }}
              >
                Camera
              </p>
            </div>

            <p
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "14px",
                // color: "black",
                fontWeight: "400"
              }}
            >
              For capturing the car
            </p>

            {cameraPermStatus === "granted"
              ? <div
                style={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: "14px",
                  color: "#ff007f",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.3rem",
                  position: "absolute",
                  bottom: "20px",
                  right: "10px"
                }}
              >
                <span>
                  <img src={tick_icon} style={{ width: "14px" }} />
                </span>
                <span>Allowed</span>
              </div>
              : cameraPermStatus === "denied"
                ? <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5rem",
                    position: "absolute",
                    bottom: "20px",
                    right: "10px"
                  }}
                >
                  <span style={{ fontSize: "10px", color: "red" }}>
                    Access denied
                  </span>
                  <button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "0.2rem",
                      border: "1.5px solid #FF0083",
                      padding: "0.1rem 0.5rem",
                      backgroundColor: "white",
                      borderRadius: "4px",
                      fontSize: "0.9rem"
                    }}
                    onClick={() => handleRetry("camera")}

                  >
                    {/* <img src={reload} style={{ width: "1rem", height: "1rem" }}></img> */}
                    <p
                      style={{
                        fontSize: "1rem",
                        fontFamily: "'Montserrat', sans-serif",
                        color: "#FF0083",
                        padding: "0.3rem",
                        cursor: "pointer"
                      }}
                    >
                      Retry
                    </p>
                  </button>
                </div>
                : cameraPermStatus === "prompt"
                  ? <button
                    className="allow-button"
                    onClick={requestCameraPermission}
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      right: "10px",
                      backgroundColor: "#ff007f"
                    }}
                    disabled={
                      cameraPermStatus === "prompt"
                        ? false
                        : cameraPermStatus === "granted"
                          ? true
                          : cameraPermStatus === "denied" ? true : true
                    }
                  >
                    {cameraPermStatus === "prompt"
                      ? "Allow"
                      : cameraPermStatus === "granted"
                        ? "Allowed"
                        : cameraPermStatus === "denied" ? "Denied" : ""}
                  </button>
                  : <p />}
          </div>
          {/* location */}
          <div
            className="permission-card"

          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                gap: "0.3rem"
              }}
            >
              <img
                src={location_icon}
                style={{ width: "20px", height: "20px" }}
              />
              <p
                style={{
                  fontFamily: "Barlow Condensed",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: ' #000000DE'
                }}
              >
                Location
              </p>
            </div>
            <p
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "14px",
                fontWeight: "400"
              }}
            >
              For the location of the inspection
            </p>
            {locationPermStatus === "granted"
              ? <div
                style={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: "14px",
                  color: "#ff007f",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.3rem",
                  position: "absolute",
                  bottom: "20px",
                  right: "10px"
                }}
              >
                <span>
                  <img src={tick_icon} style={{ width: "14px" }} />
                </span>
                <span>Allowed</span>
              </div>
              : locationPermStatus === "denied"
                ? <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5rem",
                    position: "absolute",
                    bottom: "20px",
                    right: "10px"
                  }}
                >
                  <span style={{ fontSize: "10px", color: "red" }}>
                    Access denied
                  </span>
                  <button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "0.2rem",
                      border: "1.5px solid #FF0083",
                      padding: "0.1rem 0.5rem",
                      backgroundColor: "white",
                      borderRadius: "4px",
                      fontSize: "0.9rem"
                    }}
                    onClick={() => handleRetry("location")}

                  >
                    {/* <img src={reload} style={{ width: "1rem", height: "1rem" }}></img> */}
                    <p
                      style={{
                        fontSize: "1rem",
                        fontFamily: "'Montserrat', sans-serif",
                        color: "#FF0083",
                        padding: "0.3rem",
                        cursor: "pointer"
                      }}
                    >
                      Retry
                    </p>
                  </button>
                </div>
                : locationPermStatus === "prompt"
                  ? <button
                    className="allow-button"
                    onClick={requestLocationPermission}
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      right: "10px",
                      backgroundColor:
                        locationPermStatus === "granted" ||
                          locationPermStatus === "denied"
                          ? "lightgray"
                          : "#ff007f"
                    }}
                    disabled={
                      locationPermStatus === "prompt"
                        ? false
                        : locationPermStatus === "granted"
                          ? true
                          : locationPermStatus === "denied" ? true : true
                    }
                  >
                    {locationPermStatus === "prompt"
                      ? "Allow"
                      : locationPermStatus === "granted"
                        ? "Allowed"
                        : locationPermStatus === "denied" ? "Denied" : ""}
                  </button>
                  : <p />}
          </div>
          {/* audio */}
          <div className="permission-card">
            <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-start", gap: "0.3rem" }}>
              <img src={audio_icon} style={{ width: "20px", height: "19px" }} />
              <p style={{ fontFamily: "Barlow Condensed", fontSize: "18px", fontWeight: "600", color: ' #000000DE' }}>Audio</p>
            </div>

            <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "14px", fontWeight: "400" }}>
              For video inspection
            </p>

            {audioPermStatus === "granted"
              ? <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "14px", color: "#ff007f", display: "flex", alignItems: "center", justifyContent: "center", gap: "0.3rem", position: "absolute", bottom: "20px", right: "10px" }}>
                <span><img src={tick_icon} style={{ width: "14px" }} /></span>
                <span>Allowed</span>
              </div>
              : audioPermStatus === "denied"
                ? <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", position: "absolute", bottom: "20px", right: "10px" }}>
                  <span style={{ fontSize: "10px", color: "red" }}>Access denied</span>
                  <button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FF0083", padding: "0.1rem 0.5rem", backgroundColor: "white", borderRadius: "4px", fontSize: "0.9rem" }} onClick={() => handleRetry("audio")}
                  >
                    <p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FF0083", padding: "0.3rem", cursor: "pointer" }} >Retry</p>
                  </button>
                </div>
                : audioPermStatus === "prompt"
                  ? <button className="allow-button" onClick={handleRequestPermission} style={{ position: "absolute", bottom: "10px", right: "10px", backgroundColor: "#ff007f" }} disabled={audioPermStatus !== "prompt"}>
                    {audioPermStatus === "prompt" ? "Allow" : audioPermStatus === "granted" ? "Allowed" : audioPermStatus === "denied" ? "Denied" : ""}
                  </button>
                  : <p />}
          </div>
        </div>

        <button
          // disabled={!proceedStatus}
          onClick={handleButtonClick}
          className="proceed-button"
          style={{
            backgroundColor: proceedStatus ? "#FF0083" : "#dcdcdc",
            color: proceedStatus ? "#ffffff" : "#0000003D",
            pointerEvents: proceedStatus ? "auto": "none"
          }}
        >
          Proceed
        </button>

        {/* 1 */}
        <Dialog
          open={openPermissionDialog}
          sx={{ zIndex: "99999999999999999999" }}
          // onClose={handleDialogClose}
          maxWidth="150vw"
          maxHeight="lg"
          PaperProps={{
            style: {
              width: dialogWidth,
              padding: "0.5rem 0.5rem",
              paddingBottom: "0.5rem",
              borderRadius: "4px",
              boxSizing: "border-box"
            }
          }}
        >
          <DialogTitle
            style={{
              display: 'flex',
              fontSize: dialogText,
              textAlign: "center",
              color: "black",
              paddingBottom: "0.1rem ",
              fontWeight: "bold",
              fontFamily: 'Barlow Condensed',
            }}
          >
            {/* <img
              src={camera_icon}
              style={{ width: "20px", height: "20px", marginRight: "5px" }}
            /><h6> */}
              Enable Location, Camera, Microphone Permissions
            {/* </h6> */}
          </DialogTitle>
          <DialogContent style={{ padding: "0.5rem" }}>
            <div className="enable-permissions">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly"
                }}
              >
                {/* <img src={location_gif} style={{ width: "5rem" }} />
                <img src={camera_gif} style={{ width: "5rem" }} /> */}
              </div>
              {deviceType === "Laptop" &&
                <div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>
                    1. Open info icon in the top header to view site settings.
                  </span>
                  <span>2. Go to site settings.</span>
                  <span>3. Set camera, microphone & location preferences to "ALLOW"</span>
                  {/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic"
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
                </div>}
              {deviceType === "iPhone" &&
                <div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>1. Open Settings app.</span>
                  <span>2. Search Location Services.</span>
                  <span>3. Set location as "ON".</span>
                  <span>
                    4. Below view safari/chrome -- "Allow only while using the
                    app"{" "}
                  </span>
                  <span>5. Search Camera.</span>
                  <span>
                    6. Set camera as "ON" for the browser use are using.
                  </span>
                  <span>
                    7. Set microphone as "ON" for the browser use are using.
                  </span>
                  {/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic"
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
                </div>}
              {deviceType === "Android" &&
                <div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px", }}>
                  <span>1. Open Settings app.</span>
                  <span>2. Search Location.</span>
                  <span>3. Set location as "ON".</span>
                  <span>4. Then, search "chrome" browser.</span>
                  <span>
                    5. In chrome -- permissions -- Location -- "Allow only while
                    using the app"{" "}
                  </span>
                  <span>6. Search Camera.</span>
                  <span>
                    7. Set camera as "ON" for the browser use are using.
                  </span>
                  <span>
                    8. Set microphone as "ON" for the browser use are using.
                  </span>
                  {/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic"
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
                </div>}
              {deviceType === "Unknown Device" &&
                <div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>1. Open Settings app.</span>
                  <span>2. Search Location.</span>
                  <span>3. Set location as "ON".</span>
                  <span>4. Then, search "chrome" browser.</span>
                  <span>
                    5. In chrome -- permissions -- Location -- "Allow only while
                    using the app"{" "}
                  </span>
                  <span>6. Search Camera.</span>
                  <span>
                    7. Set camera as "ON" for the browser use are using.
                  </span>
                  {/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic",
                      fontFamily: 'Montserrat'
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
                </div>}
              <div style={{
                display: 'flex',
                justifyContent: 'flex-end', // Aligns the button to the right
                marginTop: '10px' // Adds some space above the button
              }}>
                <Button
                  variant="outlined"
                  className="close-permissions-dialog"
                  style={{
                    alignSelf: 'flex-end', // Align the button to the end vertically
                    padding: '6px 20px', // Optional: Adjust padding for better look
                    fontSize: '14px',
                    background: '#ff0083',
                    color: '#ffffff',
                    border: 'none'
                  }}
                  onClick={() => {
                    setOpenPermissionDialog(false);
                  }}
                >
                  OK
                </Button>
              </div>

            </div>
            {/* </MuiAlert> */}
          </DialogContent>
        </Dialog>

        {/* 2 */}
        <Dialog
          open={openLocPermissionDialog}
          sx={{ zIndex: "99999999999999999999" }}
          // onClose={handleDialogClose}
          maxWidth="150vw"
          maxHeight="lg"
          PaperProps={{
            style: {
              width: dialogWidth,
              padding: "0.5rem 0.5rem",
              paddingBottom: "0.5rem",
              borderRadius: "4px",
              boxSizing: "border-box"
            }
          }}
        >
          <DialogTitle
            style={{
              display: 'flex',
              alignItems:"center",
              justifyContent:"flex-start",
              textAlign: "center",
              color: "black",
            
              fontWeight: "bold",
              fontFamily: 'Barlow Condensed',
              fontSize:"1rem",
             padding: "1rem 0.5rem 0rem 0.5rem",
            }}
          >
            <img
              src={location_icon}
              style={{ width: "20px", height: "20px", marginRight: "5px" }}
            />
            <span>
              Enable Location permissions
            </span>
          </DialogTitle>
          <DialogContent style={{ padding: "0.5rem" }}>
            <div className="enable-permissions">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly"
                }}
              >
                {/* <img src={location_gif} style={{ width: "5rem" }} /> */}
              </div>

              {deviceType === "Laptop" &&
                <div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>
                    1. Open info icon in the top header to view site settings.
                  </span>
                  <span>2. Go to site settings.</span>
                  <span>3. Set location preference to "ALLOW"</span>
                  {/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic"
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
                </div>}
              {deviceType === "iPhone" &&
                <div style={{ listStyleType: "decimal", textAlign: "justify", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>1. Open Settings app.</span>
                  <span>2. Search Location Services.</span>
                  <span>3. Set location as "ON".</span>
                  <span>
                    4. Below view safari/chrome -- "Allow only while using the
                    app"{" "}
                  </span>
                  {/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic"
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
                </div>}
              {deviceType === "Android" &&
                <div style={{ listStyleType: "decimal", textAlign: "justify", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>1. Open Settings app.</span>
                  <span>2. Search Location.</span>
                  <span>3. Set location as "ON".</span>
                  <span>4. Then, search "chrome" browser.</span>
                  <span>
                    5. In chrome -- permissions -- Location -- "Allow only while
                    using the app"{" "}
                  </span>
                  {/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic"
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
                </div>}
              {deviceType === "Unknown Device" &&
                <div style={{ listStyleType: "decimal", textAlign: "justify", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>1. Open Settings app.</span>
                  <span>2. Search Location.</span>
                  <span>3. Set location as "ON".</span>
                  <span>4. Then, search "chrome" browser.</span>
                  <span>
                    5. In chrome -- permissions -- Location -- "Allow only while
                    using the app"{" "}
                  </span>
                  {/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic"
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
                </div>}

              <div style={{
                display: 'flex',
                justifyContent: 'flex-end', // Aligns the button to the right
                marginTop: '10px' // Adds some space above the button
              }}>
                <Button
                  variant="outlined"
                  className="close-permissions-dialog"
                  style={{
                    alignSelf: 'flex-end', // Align the button to the end vertically
                    padding: '6px 20px', // Optional: Adjust padding for better look
                    fontSize: '14px',
                    background: '#ff0083',
                    color: '#ffffff',
                    border: 'none'
                  }}
                  onClick={() => {
                    setOpenLocPermissionDialog(false);
                  }}
                >
                  OK
                </Button>
              </div>
            </div>
            {/* </MuiAlert> */}
          </DialogContent>
        </Dialog>
        {/* 3 */}
        <Dialog
          open={openCamPermissionDialog}
          sx={{ zIndex: "99999999999999999999" }}
          // onClose={handleDialogClose}

          maxWidth="150vw"
          maxHeight="lg"
          PaperProps={{
            style: {
              width: dialogWidth,
              padding: "0.5rem 0.5rem",
              paddingBottom: "0.5rem",
              borderRadius: "4px",
              boxSizing: "border-box"
            }
          }}
        >
          <DialogTitle
            style={{
              display: 'flex',
              alignItems:"center",
              justifyContent:"flex-start",
              textAlign: "center",
              color: "black",
            
              fontWeight: "bold",
              fontFamily: 'Barlow Condensed',
              fontSize:"1rem",
             padding: "1rem 0.5rem 0rem 0.5rem",
            }}
          >
            <img
              src={camera_icon}
              style={{ width: "20px", height: "20px", marginRight: "5px" }}
            />
            <span style={{}}>
              Enable Camera permissions
            </span>
          </DialogTitle>
          <DialogContent style={{ padding: "0.5rem" }}>
            <div className="enable-permissions">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly"
                }}
              >
                {/* <img src={camera_gif} style={{ width: "5rem" }} /> */}
              </div>
              {deviceType === "Laptop" &&
                <div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>
                    1. Open info icon in the top header to view site settings.
                  </span>
                  <span>2. Go to site settings.</span>
                  <span>3. Set camera preference to "ALLOW"</span>
                  {/* <span>--- Reload the page ---</span> */}
                </div>}
              {deviceType === "iPhone" &&
                <div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>1. Open Settings app.</span>
                  <span>2. Search Camera.</span>
                  <span>
                    3. Set camera as "ON" for the browser use are using.
                  </span>
                  {/* <span>--- Reload the page ---</span> */}
                </div>}
              {deviceType === "Android" &&
                <div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>1. Open Settings app.</span>
                  <span>2. Search Camera.</span>
                  <span>
                    3. Set camera as "ON" for the browser use are using.
                  </span>
                  {/* <span>--- Reload the page ---</span> */}
                </div>}
              {deviceType === "Unknown Device" &&
                <div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>1. Open Settings app.</span>
                  <span>2. Search Camera.</span>
                  <span>
                    3. Set camera as "ON" for the browser use are using.
                  </span>
                  {/* <span>--- Reload the page ---</span> */}
                </div>}

              {/* <Button
                variant="outlined"
                className="close-permissions-dialog"
                onClick={() => {
                  setOpenCamPermissionDialog(false);
                }}
              >
                OK
              </Button> */}
              <div style={{
                display: 'flex',
                justifyContent: 'flex-end', // Aligns the button to the right
                marginTop: '10px' // Adds some space above the button
              }}>
                <Button
                  variant="outlined"
                  className="close-permissions-dialog"
                  style={{
                    alignSelf: 'flex-end', // Align the button to the end vertically
                    padding: '6px 20px', // Optional: Adjust padding for better look
                    fontSize: '14px',
                    background: '#ff0083',
                    color: '#ffffff',
                    border: 'none'
                  }}
                  onClick={() => {
                    setOpenCamPermissionDialog(false);
                  }}
                >
                  OK
                </Button>
              </div>
            </div>
            {/* </MuiAlert> */}
          </DialogContent>
        </Dialog>
        {/* 4 */}
        <Dialog
          open={openAudioPermissionDialog}
          sx={{ zIndex: "99999999999999999999" }}
          // onClose={handleDialogClose}

          maxWidth="150vw"
          maxHeight="lg"
          PaperProps={{
            style: {
              width: dialogWidth,
              padding: "0.5rem 0.5rem",
              paddingBottom: "0.5rem",
              borderRadius: "4px",
              boxSizing: "border-box"
            }
          }}
        >
         <DialogTitle
            style={{
              display: 'flex',
              alignItems:"center",
              justifyContent:"flex-start",
              textAlign: "center",
              color: "black",
            
              fontWeight: "bold",
              fontFamily: 'Barlow Condensed',
              fontSize:"1rem",
             padding: "1rem 0.5rem 0rem 0.5rem",
            }}
          >
            <img
              src={audio_icon}
              style={{ width: "20px", height: "20px", marginRight: "5px" }}
            />
            <span>
              Enable Microphone permissions
            </span>
          </DialogTitle>
          <DialogContent style={{ padding: "0.5rem" }}>
            <div className="enable-permissions">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly"
                }}
              >
                {/* <img src={camera_gif} style={{ width: "5rem" }} /> */}
              </div>
              {deviceType === "Laptop" &&
                <div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>
                    1. Open info icon in the top header to view site settings.
                  </span>
                  <span>2. Go to site settings.</span>
                  <span>3. Set microphone preference to "ALLOW"</span>
                  {/* <span>--- Reload the page ---</span> */}
                </div>}
              {deviceType === "iPhone" &&
                <div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>1. Open Settings app.</span>
                  <span>2. Search microphone.</span>
                  <span>
                    3. Set microphone as "ON" for the browser use are using.
                  </span>
                  {/* <span>--- Reload the page ---</span> */}
                </div>}
              {deviceType === "Android" &&
                <div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>1. Open Settings app.</span>
                  <span>2. Search microphone.</span>
                  <span>
                    3. Set microphone as "ON" for the browser use are using.
                  </span>
                  {/* <span>--- Reload the page ---</span> */}
                </div>}
              {deviceType === "Unknown Device" &&
                <div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
                  <span>1. Open Settings app.</span>
                  <span>2. Search microphone.</span>
                  <span>
                    3. Set microphone as "ON" for the browser use are using.
                  </span>
                  {/* <span>--- Reload the page ---</span> */}
                </div>}

              {/* <Button
                variant="outlined"
                className="close-permissions-dialog"
                onClick={() => {
                  setOpenCamPermissionDialog(false);
                }}
              >
                OK
              </Button> */}
              <div style={{
                display: 'flex',
                justifyContent: 'flex-end', // Aligns the button to the right
                marginTop: '10px' // Adds some space above the button
              }}>
                <Button
                  variant="outlined"
                  className="close-permissions-dialog"
                  style={{
                    alignSelf: 'flex-end', // Align the button to the end vertically
                    padding: '6px 20px', // Optional: Adjust padding for better look
                    fontSize: '14px',
                    background: '#ff0083',
                    color: '#ffffff',
                    border: 'none'
                  }}
                  onClick={() => {
                    setOpenAudioPermissionDialog(false);
                  }}
                >
                  OK
                </Button>
              </div>
            </div>
            {/* </MuiAlert> */}
          </DialogContent>
        </Dialog>
        {speed && speed<5 &&  <Dialog
            open={openDialogLowInternet}
            onClose={handleDialogClose}
            maxWidth="150vw"
            maxHeight="lg"
            PaperProps={{
              style: {
                width: dialogWidth,
                // padding: "1.5rem 1rem",
                // paddingBottom: "0.5rem",
                borderRadius: "4px",
                margin: "0px",
                height: "120px",
                zIndex: "999999"
              },
            }}
          >


            <DialogTitle
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",

                gap: "0.3rem",
                fontSize: "1.3rem",
                textAlign: "center",
                color: "black",
                padding: "1rem 0.9rem",
                fontWeight: "600",
                fontFamily: 'Barlow Condensed',
              }}
            >

             
             
                <>
                  <img src={network} style={{ width: "9%" }} />
                  <span >Low internet connection</span>
                </>
             
            </DialogTitle>
            <div style={{ padding: "0 1rem", fontFamily: "'Montserrat', sans-serif", }} >
              Please switch to a more stable connection to continue seamlessly
            </div>
            <IconButton
                                aria-label="close"
                                onClick={handleDialogClose}
                                sx={{
                                    position: "absolute",
                                    right: 7,
                                    top: 10,
                                    color: "black",
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
          </Dialog>}
      </div>
    </div >
  );
};

export default Permission;
